import React, { useState } from "react";
import ContentInput from "./ContentInput";
import SectionList from "./SectionList";
import SectionEditor from "./SectionEditor";
import MetadataForm from "./MetadataForm";
import {
  moveSectionUp,
  moveSectionDown,
  deleteSection,
  updateSectionContent,
  reclassifySection,
} from "../utils/parser";
import "../styles/ContentInput.css";

const LessonCreateTab = () => {
  const [sections, setSections] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [showMetadataForm, setShowMetadataForm] = useState(false);
  const [saveStatus, setSaveStatus] = useState("");

  const handleParse = (parsedSections) => {
    setSections(parsedSections);
    setEditingIndex(null);
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
  };

  const handleSaveEdit = (newSection, index) => {
    const [newType, newContent] = newSection;
    let updated = updateSectionContent(sections, index, newContent);
    if (sections[index][0] !== newType) {
      updated = reclassifySection(updated, index, newType);
    }
    setSections(updated);
    setEditingIndex(null);
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
  };

  const handleDelete = (index) => {
    setSections(deleteSection(sections, index));
  };

  const handleMove = (index, direction) => {
    if (direction === "up") {
      setSections(moveSectionUp(sections, index));
    } else if (direction === "down") {
      setSections(moveSectionDown(sections, index));
    }
  };

  const handleReclassify = (index) => {
    setEditingIndex(index);
  };

  const handleSaveLessonClick = () => {
    if (sections.length === 0) {
      alert("Please parse and review content before saving");
      return;
    }
    setShowMetadataForm(true);
  };

  const handleMetadataFormSave = (lesson) => {
    setShowMetadataForm(false);
    setSaveStatus("✅ Lesson saved successfully!");
    setSections([]);

    setTimeout(() => setSaveStatus(""), 3000);
  };

  const handleMetadataFormCancel = () => {
    setShowMetadataForm(false);
  };

  return (
    <div className="tab-content">
      <ContentInput onParse={handleParse} />

      {sections.length > 0 && (
        <>
          <SectionList
            sections={sections}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onMove={handleMove}
            onReclassify={handleReclassify}
          />

          <div className="save-section">
            <button className="save-button" onClick={handleSaveLessonClick}>
              💾 Save as Lesson
            </button>
          </div>
        </>
      )}

      {saveStatus && <div className="save-status">{saveStatus}</div>}

      {editingIndex !== null && sections[editingIndex] && (
        <SectionEditor
          section={sections[editingIndex]}
          index={editingIndex}
          onSave={handleSaveEdit}
          onCancel={handleCancelEdit}
        />
      )}

      {showMetadataForm && (
        <MetadataForm
          sections={sections}
          onSave={handleMetadataFormSave}
          onCancel={handleMetadataFormCancel}
        />
      )}
    </div>
  );
};

export default LessonCreateTab;
